const FAQItems = [
  {
    answerTitle: "Frequently Asked Questions/Register log in",
    questionTitle: "sign up and log in",
    id: "0",
    src: "user",
    toggler: "toggle0",
    array: [
      {
        question: "What are the steps to register and enter coinnik Market?",
        answer: "What_steps_to_register",
        id: "toggler1",
      },
      {
        question:
          "Is it possible to log in directly to coinnik Market with a Google account?",
        answer:
          'Yes, you can create an account directly without having to fill out a registration form via the "Sign in with Google" option and your Google Account information.',
        id: "toggler2",
      },
      {
        question: "Do you have to have an ID code to register?",
        answer: "Code_represents",
        id: "toggler3",
      },
    ],
  },
  {
    answerTitle: "Frequently Asked Questions/Account",
    questionTitle: "Account",
    id: "1",
    src: "manage-accounts",
    toggler: "toggle1",
    array: [
      {
        question:
          "After registering and creating an account, what steps should be taken to upgrade the user level?",
        answer:
          "To upgrade your user interface and access all the features of the Kevin Nick Market platform, you need to complete the authentication steps.",
        id: "toggler1",
      },
      {
        question: "How to know your user level?",
        answer:
          "As soon as you first log in to the user panel, you can see the status of your account under the first and last name in the top bar of the panel.",
        id: "toggler2",
      },
      {
        question: "What should be done to improve the user level?",
        answer: "Improve_level",
        id: "toggler3",
      },
      {
        question: "What features do user levels include?",
        answer: "Four_user_levels",
        id: "toggler4",
      },
      {
        question:
          "What documents are required to authenticate on the coinnik Market site?",
        answer: "Required_authenticate",
        id: "toggler5",
      },
      {
        question:
          "What is the time for reviewing and approving documents at coinnik Market?",
        answer:
          "The coinnik Market team will be with users and customers 24 hours a day, and all documents (if complete) will be reviewed and approved in less than 15 minutes.",
        id: "toggler6",
      },
      {
        question: "Why is authentication necessary?",
        answer: "According_laws",
        id: "toggler7",
      },
    ],
  },
  {
    answerTitle: "Frequently Asked Questions/Wallet",
    questionTitle: "Wallet",
    id: "2",
    src: "wallet-black",
    toggler: "toggle2",
    array: [
      {
        question: "Can purchased cryptocurrencies be stored at coinnik Market?",
        answer: "Cryptocurrencies_stored",
        id: "toggler1",
      },
      {
        question:
          "Is it possible to deposit and withdraw blockchain from coinnik Market wallet?",
        answer:
          "Yes, you can deposit and withdraw blockchain in your coinnik Market wallet at any time.",
        id: "toggler2",
      },
      {
        question: "Does coinnik Market have a wallet?",
        answer:
          "Yes, you also have a Toman wallet at coinnik Market, which you must first charge before buying a cryptocurrency. Also, after selling a cryptocurrency and conve",
        id: "toggler3",
      },
      {
        question: "How is the coinnik Market wallet secured?",
        answer: "CoinnikMarket_wallets",
        id: "toggler4",
      },
    ],
  },
  {
    answerTitle: "Frequently Asked Questions/thread process",
    questionTitle: "Transaction process",
    id: "3",
    src: "thread",
    toggler: "toggle3",
    array: [
      {
        question: "How to buy digital currencies at coinnik Market?",
        answer: "Buy_digital_currencies",
        id: "toggler1",
      },
      {
        question: "How to sell digital currencies in coinnik Market?",
        answer: "Digital_currency_trading",
        id: "toggler2",
      },
      {
        question: "How is the transaction fee calculated in coinnik Market?",
        answer: "Coinnik Market_fee",
        id: "toggler3",
      },
    ],
  },
  {
    answerTitle: "Frequently Asked Questions/Tickets and support",
    questionTitle: "Tickets and support",
    id: "4",
    src: "person-question",
    toggler: "toggle4",
    array: [
      {
        question: "What is the support period for coinnik Market?",
        answer: "Support_coinnik_market",
        id: "toggler1",
      },
      {
        question: "How can we contact the coinnik Market support team?",
        answer:
          "You can contact the support team via phone, online chat, tickets and social media.",
        id: "toggler2",
      },
      {
        question: "How to send a ticket at coinnik Market?",
        answer: "Keep_binance_description",
        id: "toggler3",
      },
      {
        question: "What is online chat like in coinnik Market?",
        answer:
          "From the orange circle at the bottom left of the user panel, you can chat online with the coinnik Market support team.",
        id: "toggler4",
      },
      {
        question:
          "Where can we find the phone number and office address of coinnik Market?",
        answer:
          "You can access the coinnik Market phone number and address from the Contact Us page.",
        id: "toggler4",
      },
    ],
  },
  {
    answerTitle: "Frequently Asked Questions/Security and Market",
    questionTitle: "Market and security",
    id: "5",
    src: "market",
    toggler: "toggle5",
    array: [
      {
        question: "What does coinnik Market mean?",
        answer: "Coinnik_Market_mean",
        id: "toggler1",
      },
      {
        question: "How does coinnik Market work?",
        answer: "Coinnik_Market_work",
        id: "toggler2",
      },
      {
        question: "Why trust coinnik Market?",
        answer:
          "Trust and protection of users' assets is the main goal of the coinnik Market team. The coinnik Market team is committed and expert and will always be there to meet users' needs and questions.",
        id: "toggler3",
      },
      {
        question: "How is the coinnik Market platform secured?",
        answer: "Coinnik_Market_secured",
        id: "toggler4",
      },
      {
        question:
          "What is the security level of coinnik Market Security Protocol?",
        answer: "Protocol_coinnik",
        id: "toggler5",
      },
      {
        question: "Does coinnik Market have a physics office?",
        answer:
          "Yes, you can access the coinnik Market address and phone number through the Contact Us page.",
        id: "toggler6",
      },
    ],
  },
];

export default FAQItems;
